import React from 'react';
import styled from 'styled-components';
import { Row, Card, Button } from 'antd';

interface Props {
  titleText: string;
  bodyText: string | React.ReactNode;
  buttonText?: string;
  buttonLink?: string;
}

const StyledCard = styled(Card)`
  height: 100%;
  .ant-card-body {
    height: 100%;
  }
`;

const CardContentWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const ShortcutCard: React.FC<Props> = ({
  titleText,
  bodyText,
  buttonText,
  buttonLink,
}) => (
  <StyledCard variant="borderless">
    <CardContentWrapper>
      <div>
        <Row css="text-transform: uppercase; color: rgba(0, 0, 0, 0.45)">
          {titleText}
        </Row>
        {typeof bodyText === 'string' ? (
          <Row css="font-weight: 500; font-size: 24px">{bodyText}</Row>
        ) : (
          <Row>{bodyText}</Row>
        )}
      </div>
      {buttonText && buttonLink && (
        <Row justify="end">
          <Button
            type="primary"
            href={buttonLink}
            target="_blank"
            css="float: right; margin-top: 10px"
          >
            {buttonText}
          </Button>
        </Row>
      )}
    </CardContentWrapper>
  </StyledCard>
);

export default ShortcutCard;
